import styled from 'styled-components';

export const ImpInfoCont = styled.div`
    border-radius: 0.4rem;
    background-color: #ffffff;
    margin: ${p => p.margin ? p.margin : ''};
`;
export const ImpInfoHeader = styled.div`
    padding: 2.3rem 3rem 2rem 3rem;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    h3{
        font-family: 'Rubik';
        font-size: 1.8rem;
        line-height: 2.4rem;
        font-weight: 600;
        color: ${p => p.theme ? p.theme.colors.black.base : '#141823'};
    }
`;
export const ImpInfoContent = styled.div`
    padding: 2.3rem 3rem;
    border-top: 0.1rem #e5edf6 solid;
    .infoList{
        display: grid;
        grid-template-columns: 1fr;
        grid-gap: 1.5rem;
        >li{
            font-size: 1.4rem;
            line-height: 1.8rem;
            color: ${p => p.theme ? p.theme.colors.grey.grey75 : '#4f525a'};
            padding-left: 1.4rem;
            position: relative;
            ::before{
                content: "";
                width: 0.6rem;
                height: 0.6rem;
                background-color: #2276e3;
                border-radius: 50%;
                position: absolute;
                left: 0;
                top: 0.6rem;
            }
        }
    }
`;

